import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import "./coach-landing.css";
import { PRECIO_ANUAL } from "../../config/precios";

export default function CoachLandingFAQ() {
  const [activeIndex, setActiveIndex] = useState(-1);

  const faqs = [
    {
      question: "¿De verdad es gratis para coaches?",
      answer: "Sí, al 100%. No pagas suscripción, ni comisiones sobre tus servicios, ni cuotas de alta, ni por volumen de clientes"
    },
    {
      question: "¿Por qué es gratis? ¿Dónde está el truco?",
      answer: "No hay truco. Wayo gana dinero con las suscripciones Premium de los usuarios de la app, no cobrándote a ti. A nosotros nos interesa que traigas a tus clientes a Wayo. Tú usas la plataforma gratis; nosotros crecemos con la comunidad. Lo que otras plataformas como Harbiz cobran de 14 a 199 € al mes, aquí no te cuesta nada."
    },
    {
      // Harbiz lo tiene en su portada («100 % gratuito para tus clientes») y
      // aquí no se decía en ningún sitio, cuando el cliente del coach TIENE que
      // ser Premium (lo exige el backend al vincularlo). Fue lo primero que
      // preguntó un box de la captación el 26-sep. Mejor que lo lean aquí.
      question: "¿Mis clientes tienen que pagar algo?",
      answer: `Sí, y te lo decimos claro: para que puedas llevarlos desde Wayo, tus clientes necesitan Wayo Premium (${PRECIO_ANUAL} al año). Es la app con la que siguen tu plan, escanean su comida por foto y hablan con el asistente. Lo pagan ellos a Wayo, no a ti, y si quieres puedes incluirlo en tu tarifa. Tú no pagas nada.`
    },
    {
      question: "¿Hay límite de clientes?",
      answer: "No. Puedes gestionar tantos clientes como necesites, sin restricciones. A diferencia de otras plataformas, tu precio no sube cuando creces: siempre es gratis."
    },
    {
      question: "¿Sirve como software para entrenadores personales y coaches online?",
      answer: "Sí. Wayo está pensado para entrenadores personales, nutricionistas y coaches online que quieren centralizar clientes, planes, contenido y seguimiento en una sola plataforma."
    },
    {
      question: "¿Vale para coaching de hábitos y nutrición, no solo entrenamiento?",
      answer: "Sí. La parte de nutrición va incluida: planes de comidas y escaneo de comida por foto para tus clientes, dentro de la misma app."
    },
    {
      question: "¿Qué ventaja tiene frente a llevarlo por WhatsApp, PDF o Excel?",
      answer: "Ahorras tiempo, reduces errores y das una experiencia mucho más profesional. Tus clientes tienen su contenido en la app, tú gestionas mejor el seguimiento y no dependes de enviar todo manualmente."
    },
    {
      question: "¿Mis clientes verán mis entrenamientos como propios?",
      answer: "Sí. Tu nombre, tu foto, tu estilo. Es tu contenido y lo mostramos como tuyo."
    },
    {
      question: "¿Puedo cancelar cuando quiera?",
      answer: "Sí, cuando quieras: no hay permanencia ni nada que firmar. Si tienes clientes activos, escríbenos y lo cerramos juntos para que ninguno se quede sin su plan."
    },
    {
      question: "¿Hay ayuda o soporte?",
      answer: "Sí. Dentro del panel tienes un vídeo de cómo funciona y, en cada apartado, para qué sirve. Y si te atascas, escribe a soporte@wayoai.app: te contesta el fundador."
    },
    {
      question: "¿Puedo usar Wayo para mis clientes online y presenciales?",
      answer: "Sí. Wayo es perfecto tanto para coaches online como presenciales. Tus clientes pueden acceder a sus planes desde la app, ya estén en casa o en el gimnasio contigo."
    },
    {
      question: "¿Puedo cobrar a mis clientes dentro de la App?",
      answer: "No. Actualmente no gestionamos pagos dentro de la app. Tú decides cómo cobrar a tus clientes (PayPal, transferencia, etc) y nosotros te damos las herramientas para que les ofrezcas un servicio de calidad."
    }
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: { "@type": "Answer", text: f.answer }
    }))
  };

  return (
    <section className="faq-section" id="faq">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      </Helmet>
      <div className="container">
        <div className="faq-header" style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center" }}>
          <div className="section-tag">Preguntas frecuentes</div>
          <h2 className="section-title">¿Tienes dudas? Las resolvemos.</h2>
          <p className="section-subtitle" style={{ marginBottom: "40px", maxWidth: "760px" }}>
            Respuestas directas para coaches que están comparando software para entrenadores personales, herramientas para coaches online y alternativas a trabajar con todo en manual.
          </p>
        </div>
        {/* El ancho y las columnas los pone .faq-list en el CSS: en línea no se
            pueden aplicar media queries y bloqueaba las 2 columnas de escritorio. */}
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className={`faq-item ${activeIndex === index ? "active" : ""}`} style={{
              ...(activeIndex === index && {
                background: "rgba(255,255,255,0.5)",
                borderColor: "var(--primary-light)"
              })
            }}>
              <button
                className="faq-question"
                onClick={() => setActiveIndex(activeIndex === index ? -1 : index)}
              >
                {faq.question}
                <span className="faq-icon">
                  {activeIndex === index ? "−" : "+"}
                </span>
              </button>
              <div className="faq-answer">
                <div className="faq-answer-inner">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
